// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BO0Xv25mQWLIqYTQlodX>div{min-height:fit-content}`, "",{"version":3,"sources":["webpack://./src/entities/Phone/ui/QuestionnaireOrSelectNumberModal/store/styles.module.scss"],"names":[],"mappings":"AACE,0BACE,sBAAA","sourcesContent":[".questionnaireOrSelectNumberModal {\n  > div {\n    min-height: fit-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionnaireOrSelectNumberModal": `BO0Xv25mQWLIqYTQlodX`
};
export default ___CSS_LOADER_EXPORT___;
